import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "flex items-center gap-1.5 text-xs",
  "aria-label": "Progress"
}
const _hoisted_2 = ["aria-current"]


export default {
  __name: 'MarketingPlayTimeline',
  props: {
  steps: { type: Array, required: true },
  current: { type: Number, default: 0 },
  failed: { type: Boolean, default: false }
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("ol", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.steps, (step, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: step }, [
        _createElementVNode("li", {
          class: _normalizeClass(i === __props.current ? (__props.failed ? 'font-bold text-red-700' : 'font-bold text-gray-900') : 'text-gray-500'),
          "aria-current": i === __props.current ? 'step' : undefined
        }, _toDisplayString(step), 11, _hoisted_2),
        (i < __props.steps.length - 1)
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              "aria-hidden": "true",
              class: _normalizeClass(["h-0.5 w-5 rounded", i < __props.current ? 'bg-gray-900' : 'bg-gray-200'])
            }, null, 2))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

}